module.exports = __webpack_public_path__ + "static/media/cross-icon.7c6b8183.svg";